import { createGlobalStyle } from 'styled-components';
import {
  primaryFont, primaryHeadingColor, textTruncateSnippetFour, wMedium,
} from '../Utils/utilsStyle';

const GeneralStyleV2 = createGlobalStyle`
.image-title-tooltip-gilroy {
  .ant-tooltip-content {
    border-radius: 8px;
    .ant-tooltip-inner {
      border-radius: 8px;
      color: ${primaryHeadingColor};
      font-weight: ${wMedium};
      font-style: ${primaryFont};
      max-height: 100px;
      overflow: hidden;
      ${textTruncateSnippetFour};
    }
  }
}
`;
export default GeneralStyleV2;
